import { reactive } from 'vue'

/** Segmentos de URL reservados (não são master_code do tenant na área pública) */
export const RESERVED_FIRST_SEGMENTS = new Set([
  'admin',
  'api',
  'rails',
  'public',
  'up',
  'about',
  'vite-dev',
  'vite-test'
])

export const router = reactive({
  currentRoute: 'dashboard',
  params: {}
})

function pathnameNormalized() {
  const p = window.location.pathname.replace(/\/+$/, '')
  return p === '' ? '/' : p
}

/**
 * Base pública para montar URLs (/, /:master_code ou /:master_code/about).
 */
export function getPublicBasePath() {
  let p = pathnameNormalized()
  if (p === '/') return '/'
  p = p.replace(/\/about$/, '')
  if (p === '') return '/'
  return p
}

/**
 * Sincroniza router reativo com pathname atual (carga inicial e botão voltar).
 */
export function applyLocationToRouter() {
  const path = pathnameNormalized()

  if (path === '/admin') {
    router.currentRoute = 'admin'
    router.params = {}
    return
  }

  if (path === '/about') {
    router.currentRoute = 'about'
    router.params = {}
    return
  }

  let m = path.match(/^\/([a-zA-Z0-9_-]+)\/about\/?$/)
  if (m && !RESERVED_FIRST_SEGMENTS.has(m[1].toLowerCase())) {
    router.currentRoute = 'about'
    router.params = {}
    return
  }

  router.currentRoute = 'dashboard'
  router.params = {}
}

export function navigateTo(route, params = {}) {
  router.currentRoute = route
  router.params = { ...params }

  if (route === 'admin') {
    window.history.pushState({}, '', '/admin')
    return
  }

  if (route === 'dashboard') {
    const base = getPublicBasePath()
    window.history.pushState({}, '', base === '/' ? '/' : base)
    return
  }

  if (route === 'about') {
    const base = getPublicBasePath()
    const url = base === '/' ? '/about' : `${base}/about`
    window.history.pushState({}, '', url)
    return
  }

  // Rotas internas logadas (ex.: users, profile): não altera a URL
}

export function goBack() {
  navigateTo('agent-dashboard', {})
}

export function getCurrentRoute() {
  return router.currentRoute
}

export function getParams() {
  return router.params
}
